export default __webpack_public_path__ + "static/media/barea.33b97ad2.png";